var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.androidFlg == false)?_c('rxNavBar',{attrs:{"title":"试岗模板预览","androidOrIOSFlag":"true"}}):_c('rxNavBar',{attrs:{"title":"试岗模板预览"}}),_c('div',{attrs:{"id":"planInfoPreview"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }